import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
import { AppModule } from './app/app.module';
import { AppConfigSettings } from '@arc/arc-shared-frontend';

if (environment.production) {
  enableProdMode();
}

fetch('/assets/app.settings.json')
  .then(client => client.json())
  .then(config => {
    const configSetting = new AppConfigSettings();
    if (config && config.length > 0) {
      config.forEach(element => {
        for (const key in element) {
          if (element.hasOwnProperty(key)) {
            configSetting.settings.set(key, element[key]);
          }
        }
      });
    }
    if (configSetting.getconfig('appMode') === 'prod') {
      enableProdMode();
    }
    platformBrowserDynamic([{ provide: AppConfigSettings, useValue: configSetting }]).bootstrapModule(AppModule);
  });
